import React from "react";
import {
  Grid,
  FormControl,
  Divider,
  Button,
  Box,
  Paper,
  DialogContentText,
  TextField,
  Checkbox as MUICheckbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { pt } from "yup-locale-pt";
import {
  CamposProcessoInicial,
  DialogoConfirmacao,
  DialogoConfirmacaoSimples,
  FileField,
  FileListField,
  Checkbox,
  Autocomplete,
  Timestamps,
  Select,
  FloatField,
  TextField as FormTextField,
  InterlocutoresSection,
} from "../../components";
import api from "../../services/api";
import { listaEnergeticos, opcoesBooleanas2 } from "../../static";
import { useStoreState, useStoreActions } from "easy-peasy";
import { useNavigate } from "react-router-dom";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CancelIcon from "@mui/icons-material/Cancel";
import styles from "./Interesse.module.css";
import { isInterlocutorProcel, isProgramaInovacao, isProgramaProcel } from "../../helpers/programa";
import { PROGRAMA_ID } from "../../config";
yup.setLocale(pt);
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function checkValueAgainstConstraint(value, constraintFunction) {
  if (value === undefined || value == null || value === "") {
    return false;
  } else if (typeof value === "number") {
    return constraintFunction(value);
  } else {
    return constraintFunction(
      Number.parseFloat(value.replaceAll(".", "").replaceAll(",", "."))
    );
  }
}

const Interesse = () => {
  let navigate = useNavigate();
  let currProcesso = useStoreState((state) => state.processo.current);
  let selectProcesso = useStoreActions((actions) => actions.processo.select);
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  let user = useStoreState((state) => state.auth.user);
  const schema = yup
    .object({
      cnpj: yup.string().label("CNPJ").cnpj().required(),
      razaoSocial: yup.string().required().label("Razão social"),
      nomeFantasia: yup.string().required().label("Nome fantasia"),
      valMedioFatEnergia: yup
        .number()
        .required()
        .positive()
        .float()
        .label("Valor médio da fatura de todos os energéticos"),
      valorFaturamento: yup
        .number()
        .nullable()
        .float()
        .label("Faturamento"),
      numFuncs: yup
        .number()
        .required()
        .positive()
        .integer()
        .label("Número de funcionários"),
      setorAtuacaoId: yup
        .number()
        .required()
        .nullable()
        .positive()
        .integer()
        .label("Setor de atuação"),
      cep: yup.string().required().label("CEP"),
      rua: yup.string().required().label("Rua"),
      numero: yup.string().required().label("Número"),
      complemento: yup.string().nullable().label("Complemento"),
      bairro: yup.string().nullable().label("Bairro"),
      cidade: yup.string().required().label("Cidade"),
      estado: yup.string().required().label("Estado"),
      regiaoId: yup
        .number()
        .positive()
        .integer()
        .nullable()
        .label("Unidade Operacional"),
      cnaeId: yup
        .number()
        .positive()
        .integer()
        .nullable()
        .required()
        .label("CNAE"),
      porte: yup.string().nullable().label("Porte"),
      codigoPorteReceita: yup.number().nullable().label("Porte na Receita Federal"),
      optanteMei: yup.boolean().nullable().label("Optante pelo MEI"),
      classeCnae: yup.string().required().label("Classe do Cnae"),
      figuraCodigo: yup.string().nullable().label("Código da figura jurídica"),
      figuraDescricao: yup.string().nullable().label("Figura (natureza jurídica)"),
      nome: yup.string().required().label("Nome completo"),
      cpf: yup
        .string()
        .nullable()
        .when("programaId", {
          is: (programaId) => programaId === PROGRAMA_ID.PROCEL,
          then: (fieldSchema) => fieldSchema.cpf().required(),
          otherwise: (fieldSchema) => fieldSchema.notRequired(),
        })
        .label("CPF do responsável"),
      telefone: yup.string().required().label("Telefone de contato"),
      comoSoubeProgramaId: yup
        .number()
        .required()
        .nullable()
        .positive()
        .integer()
        .label("Como sua empresa soube do Programa?"),
      programaId: yup
        .number()
        .required()
        .nullable()
        .positive()
        .integer()
        .label("Qual a classificação do programa?"),
      email: yup.string().email().required().label("Email"),
      dreId: yup.number().nullable().label("DRE mais recente"),
      balancoId: yup.number().nullable().label("Balanço mais recente"),
      docsTecnicosField: yup
        .array()
        .label("Arraste documentos técnicos aqui ou clique"),
      faturasEnergiaField: yup
        .array()
        .label("Arraste 12 últimas faturas de energia elétrica"),
      energeticos: yup.array().nullable().label("Energéticos"),
      faturasEnergeticosField: yup
        .array()
        .label("Arraste as faturas dos energéticos"),
      cartaoCnpjId: yup
        .number()
        .positive()
        .nullable()
        .label("Cartão do CNPJ"),
      certNegInssId: yup
        .number()
        .positive()
        .nullable()
        .label("CADIN"),
      certRegFgtsId: yup
        .number()
        .positive()
        .nullable()
        .label("CND/CPEN/CRP"),
      crfId: yup
        .number()
        .positive()
        .nullable()
        .label("CRF"),
      certNegDebtTrabId: yup
        .number()
        .positive()
        .nullable()
        .label("Declaração"),
      // certNegDebtEstId: yup
      //   .number()
      //   .positive()
      //   .nullable()
      //   .label("Certidão negativa de débitos estaduais"),
      potencialEmissoesId: yup
        .mixed()
        .nullable()
        .label("Carregar a Calculadora Preenchida"),
      resultadoPotencialEmissoes: yup
        .number()
        .nullable()
        .when("programaId", {
          is: (programaId) => isProgramaProcel(listaProgramas.find((p) => p.id === programaId)),
          then: (fieldSchema) => fieldSchema.notRequired(),
          otherwise: (fieldSchema) => fieldSchema.required().positive().float(),
        })
        .label("Digitar o Potencial de emissões calculado (tCO2e/mês)"),
      pendenciaCnd: yup.boolean().nullable().required().label('Empresa está pendente de CND/CPEN e/ou CRF?').optional(),
      declaracaoAssinada: yup.boolean().nullable().required().label('Empresa assinou a Declaração de interesse na implementação?').optional(),
      pendenciaCadin: yup.boolean().nullable().required().label('Possui pendência no CADIN?').optional(),
      verificacaoAderencia: yup.boolean().nullable().label("Validar dados inseridos e finalizar verificação de aderência"),
      observacoesAprovacao: yup.string().nullable().label('Observações de aprovação'),
      sgtResponsavelVendaId: yup
        .number()
        .nullable()
        .when("programaId", {
          is: (programaId) => isProgramaProcel(listaProgramas.find((p) => p.id === programaId)),
          then: (fieldSchema) => fieldSchema.required().positive().integer(),
          otherwise: (fieldSchema) => fieldSchema.notRequired(),
        })
        .label('Selecione o responsável pela venda/prospecção'),
      sgtUnidadeId: yup.number().nullable().label('Estado/Unidade operacional (SGT)'),
      sgtUnidadeNome: yup.string().nullable().label('Estado/Unidade operacional (SGT)'),
    })
    .required();

  const defaultValues = {
    cnpj: "",
    razaoSocial: "",
    nomeFantasia: "",
    numFuncs: "",
    nome: "",
    cpf: "",
    telefone: "",
    email: "",
    estado: "",
    figuraCodigo: "",
    figuraDescricao: "",
    codigoPorteReceita: null,
    optanteMei: null,
    valorFaturamento: "",
    resultadoPotencialEmissoes: "",
    declaracaoAssinada: null,
    pendenciaCadin: null,
    pendenciaCnd: null,
    verificacaoAderencia: null,
    observacoesAprovacao: "",
    sgtResponsavelVendaId: null,
    sgtUnidadeId: null,
    sgtUnidadeNome: null,
    dreId: null,
    balancoId: null,
    cartaoCnpjId: null,
    certNegInssId: null,
    certRegFgtsId: null,
    crfId: null,
    certNegDebtTrabId: null,
    // certNegDebtEstId: null,
    potencialEmissoesId: null,
    regimefuncionamento: ["seg", "ter"],
  };

  const useFormRef = useForm({
    mode: "onTouched",
    resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });

  const handleDownload = async () => {
    const response = await api.http.get("/download/calculadora-adesao", {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "PotencializEE-Calculadora-Verificacao-Aderencia.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handleDownload2 = async () => {
    const response = await api.http.get("/download/termo-implementacao", {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "TermoDeImplementação-PotencializeMAF.docx");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const getRecusaMotivos = (data) => {
    const motivos = [];
    const programa = listaProgramas.find(p => p.id === data.programaId);

    if (programa) {
      // Funcionários
      if (programa.numFuncsRule && programa.numFuncsValue) {
        if (programa.numFuncsRule === ">" && data.numFuncs < programa.numFuncsValue) {
          motivos.push(`Número de funcionários deve ser maior que ${programa.numFuncsValue}`);
        }
        if (programa.numFuncsRule === "<" && data.numFuncs > programa.numFuncsValue) {
          motivos.push(`Número de funcionários deve ser menor que ${programa.numFuncsValue}`);
        }
      }

      // Energia
      if (programa.energiaRule && programa.energiaValue) {
        if (programa.energiaRule === ">" && data.valMedioFatEnergia < programa.energiaValue) {
          motivos.push(`Gastos com energia devem ser maior que ${programa.energiaValue} R$/mês`);
        }
        if (programa.energiaRule === "<" && data.valMedioFatEnergia > programa.energiaValue) {
          motivos.push(`Gastos com energia devem ser menor que ${programa.energiaValue} R$/mês`);
        }
      }

      // Emissões (não se aplica ao PROCEL, campo fica oculto/não obrigatório)
      if (!isProcel && programa.emissoesRule && programa.emissoesValue) {
        if (programa.emissoesRule === ">" && data.resultadoPotencialEmissoes < programa.emissoesValue) {
          motivos.push(`Potencial de emissões deve ser maior que ${programa.emissoesValue} tCO2e/mês`);
        }
        if (programa.emissoesRule === "<" && data.resultadoPotencialEmissoes > programa.emissoesValue) {
          motivos.push(`Potencial de emissões deve ser menor que ${programa.emissoesValue} tCO2e/mês`);
        }
      }

      // Faturamento
      if (programa.faturamentoRule && programa.faturamentoValue) {
        if (programa.faturamentoRule === ">" && data.valorFaturamento < programa.faturamentoValue) {
          motivos.push(`Faturamento deve ser maior que ${programa.faturamentoValue}`);
        }
        if (programa.faturamentoRule === "<" && data.valorFaturamento > programa.faturamentoValue) {
          motivos.push(`Faturamento deve ser menor que ${programa.faturamentoValue}`);
        }
      }

      // caso cadin esteja com pendencia(SIM) - não se aplica ao PROCEL, campo fica oculto
      if (!isProcel && data.pendenciaCadin) {
        motivos.push("Empresa não pode possuir pendência no CADIN");
      }

      // PROCEL: só a fatura de energia é obrigatória - as faturas dos energéticos
      // (combustíveis) são opcionais
      if (isProcel) {
        const temFaturaEnergia =
          data.faturasEnergia ||
          (data.faturasEnergiaField && data.faturasEnergiaField.length > 0);
        if (!temFaturaEnergia) {
          motivos.push("É necessário incluir ao menos uma fatura de energia");
        }
      }
    }

    if (!data.verificacaoAderencia) {
      motivos.push("É necessário marcar a validação dos dados");
    }

    return motivos;
  };

  const [listaProgramas, setListaProgramas] = React.useState([]);

  React.useEffect(() => {
    const fetchProgramas = async () => {
      try {
        const res = await api.http.get('/programas');
        setListaProgramas(res.data.map(normalizePrograma));
      } catch (err) {
        console.error('Erro ao carregar programas:', err);
      }
    };
    fetchProgramas();
  }, []);

  const [listaResponsaveisVenda, setListaResponsaveisVenda] = React.useState([]);

  React.useEffect(() => {
    const fetchResponsaveisVenda = async () => {
      try {
        const res = await api.http.get('/sgt/responsaveis-venda');
        setListaResponsaveisVenda(res.data);
      } catch (err) {
        console.error('Erro ao carregar responsáveis pela venda (SGT):', err);
      }
    };
    fetchResponsaveisVenda();
  }, []);

  const {
    watch,
    handleSubmit,
    reset,
    getValues,
    setValue,
    formState: { isDirty, isSubmitting, errors },
  } = useFormRef;

  React.useEffect(() => {
    const firstErrorKey = Object.keys(errors)[0];
    if (firstErrorKey) {
      const el = document.querySelector(`[name="${firstErrorKey}"]`);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        el.focus();
      }
    }
  }, [errors]);

  const [aprovando, setAprovando] = React.useState([]);
  const [confirmacaoMsg, setConfirmacaoMsg] = React.useState([]);

  const watchNumFuncs = watch("numFuncs", "");
  const watchValMedioFatEnergia = watch("valMedioFatEnergia", "");
  const watchResultadoPotencialEmissoes = watch("resultadoPotencialEmissoes", "");
  const watchValorFaturamento = watch("valorFaturamento", "");
  const watchProgramaId = watch("programaId");
  const normalizePrograma = (p) => ({
    ...p,
    numFuncsRule: p.num_funcs_rule,
    numFuncsValue: p.num_funcs_value,
    emissoesRule: p.emissoes_rule,
    emissoesValue: p.emissoes_value,
    energiaRule: p.energia_rule,
    energiaValue: p.energia_value,
    faturamentoRule: p.faturamento_rule,
    faturamentoValue: p.faturamento_value,
  });

  const programasFiltrados = listaProgramas.filter(
    (p) => p.active
  );

  const programaSelecionado = listaProgramas.find(
    (p) => p.id === watchProgramaId
  );
  const programaInovacaoSelecionado = isProgramaInovacao(programaSelecionado);
  const isProcel = isProgramaProcel(programaSelecionado);
  const programaMafSelecionado = [
    PROGRAMA_ID.MAF,
    PROGRAMA_ID.MAF_140H,
  ].includes(Number(watchProgramaId));
  const declaracaoDesabilitada =
    programaInovacaoSelecionado || programaMafSelecionado;
  const usuarioPodeConcluirInovacao =
    (!programaMafSelecionado || user?.roleId === "superAdmin") &&
    (!programaInovacaoSelecionado ||
      user?.email?.trim().toLowerCase() === "plinio.souza@sp.senai.br");

  React.useEffect(() => {
    if (declaracaoDesabilitada) {
      setValue("certNegDebtTrabId", null, { shouldDirty: true });
      setValue("declaracaoAssinada", false, { shouldDirty: true });
    }
  }, [declaracaoDesabilitada, setValue]);

  const [openRecusaDialog, setOpenRecusaDialog] = React.useState(false);
  const [pendingData, setPendingData] = React.useState(null);
  const [recusaMotivos, setRecusaMotivos] = React.useState([]);

  const handleSalvarClick = (mode) => (data) => {
    if (mode === "save") {
      salva({
        ...data,
        estagio: currProcesso?.estagio || "interesse",
      }, "save");
      return;
    }

    const motivos = getRecusaMotivos(data);
    setPendingData(data);
    setRecusaMotivos(motivos);

    if (currProcesso && currProcesso.estagio !== "interesse") {
      salva({ ...data }, "save");
    } else {
      setOpenRecusaDialog(true);
    }
  };

  const handleConfirmRecusa = () => {
    salva({ ...pendingData }, "conclude");
    setOpenRecusaDialog(false);
  };

  const handleCancelRecusa = () => {
    setOpenRecusaDialog(false);
    setPendingData(null);
  };

  const getErrorsAderencia = (data) => {
    const motivos = getRecusaMotivos(data);
    if (motivos.length > 0) {
      return [
        "Recusado automaticamente pelo sistema por não atingir os seguintes critérios:",
        ...motivos,
      ].join("\n");
    }
    return null;
  };

  const getPendenciasPreenchimento = () => {
    let erros = [];
    if (!isProcel && !getValues("dreId")) {
      erros.push("Inclusão do DRE mais recente");
    }
    if (!isProcel && !getValues("balancoId")) {
      erros.push("Inclusão do balanço mais recente");
    }
    if (!getValues("cartaoCnpjId")) {
      erros.push("Inclusão do cartão do CNPJ");
    }
    if (!isProcel && !getValues("certNegInssId")) {
      erros.push("Inclusão do CADIN");
    }
    if (!isProcel && !getValues("certRegFgtsId")) {
      erros.push("Inclusão do CND/CPEN/CRP");
    }
    if (!isProcel && !getValues("crfId")) {
      erros.push("Inclusão do CRF");
    }
    if (!isProcel && !declaracaoDesabilitada && !getValues("certNegDebtTrabId")) {
      erros.push("Inclusão da declaração");
    }
    // if (!getValues("certNegDebtEstId")) {
    //   erros.push("Inclusão da certidão negativa de débitos estaduais");
    // }
    if (
      !getValues("faturasEnergia") &&
      (!getValues("faturasEnergiaField") ||
        getValues("faturasEnergiaField").length === 0)
    ) {
      erros.push("Inclusão das últimas 12 faturas de energia elétrica");
    }

    // faturas dos energéticos (combustíveis) são opcionais no PROCEL
    if (
      !isProcel &&
      !getValues("faturasEnergeticos") &&
      (!getValues("faturasEnergeticosField") ||
        getValues("faturasEnergeticosField").length === 0)
    ) {
      erros.push("Inclusão das faturas dos energéticos");
    }
    if (
      !getValues("docsTecnicos") &&
      (!getValues("docsTecnicosField") ||
        getValues("docsTecnicosField").length === 0)
    ) {
      erros.push("Inclusão dos documentos técnicos");
    }
    if (erros.length > 0) {
      return [
        "Aprovado automaticamente pelo sistema com as seguintes pendências: ",
        ...erros,
      ].join("\n");
    } else {
      return null;
    }
  };

  const verificaPreenchimento = () => {
    let erros = [];
    if (!isProcel && !getValues("dreId")) erros.push("Inclusão do DRE mais recente");
    if (!isProcel && !getValues("balancoId")) erros.push("Inclusão do balanço mais recente");
    if (erros.length > 0)
      return (
        <React.Fragment>
          <DialogContentText>
            Ainda não foram realizadas as seguintes ações:
          </DialogContentText>
          <ul>
            {erros.map((erro, index) => (
              <li key={index}>
                <DialogContentText>{erro}</DialogContentText>
              </li>
            ))}
          </ul>
        </React.Fragment>
      );
    return "";
  };

  const aprova = (data) => {
    setAprovando(true);
    setConfirmacaoMsg(
      <React.Fragment>
        {verificaPreenchimento()}
        <DialogContentText>
          Esta ação não pode ser desfeita. Tem certeza que deseja <b>aprovar</b>{" "}
          o início?
        </DialogContentText>
      </React.Fragment>
    );
    setOpenConfirmacao(true);
  };

  const recusa = () => {
    setAprovando(false);
    setConfirmacaoMsg(
      <React.Fragment>
        Esta ação não pode ser desfeita. Tem certeza que deseja <b>reprovar</b>{" "}
        o início?
      </React.Fragment>
    );
    setOpenConfirmacao(true);
  };

  const desfazerRecusa = () => {
    setOpenConfirmaDesfRecusa(true);
  };

  const comIdsDasListasDeArquivos = (data) => {
    const idsDaLista = (field, idsField) => {
      if (!Array.isArray(data[field])) return data[idsField];
      return data[field]
        .map((fileObject) => fileObject?.data?.id)
        .filter((id) => id != null && Number.isInteger(Number(id)))
        .map(Number);
    };

    return {
      ...data,
      docsTecnicosIds: idsDaLista("docsTecnicosField", "docsTecnicosIds"),
      faturasEnergiaIds: idsDaLista("faturasEnergiaField", "faturasEnergiaIds"),
      faturasEnergeticosIds: idsDaLista(
        "faturasEnergeticosField",
        "faturasEnergeticosIds"
      ),
    };
  };

  const dadosProcessoParaFormulario = (processo) => {
    const arquivosDaLista = (lista) =>
      (lista?.arquivos || []).map((arquivoLista) => ({
        file: new File([], arquivoLista.arquivo.fileName, {
          type: arquivoLista.arquivo.mimeType,
        }),
        data: arquivoLista.arquivo,
      }));

    const docsTecnicosField = arquivosDaLista(processo.docsTecnicos);
    const faturasEnergiaField = arquivosDaLista(processo.faturasEnergia);
    const faturasEnergeticosField = arquivosDaLista(
      processo.faturasEnergeticos
    );

    return {
      ...processo,
      pendenciaCnd: processo.pendenciaCnd === 1,
      pendenciaCadin: processo.pendenciaCadin === 1,
      declaracaoAssinada: processo.declaracaoAssinada === 1,
      verificacaoAderencia: processo.verificacaoAderencia === 1,
      observacoesAprovacao: processo.observacoesAprovacao || "",
      docsTecnicosField,
      docsTecnicosIds: docsTecnicosField.map(({ data }) => data.id),
      faturasEnergiaField,
      faturasEnergiaIds: faturasEnergiaField.map(({ data }) => data.id),
      faturasEnergeticosField,
      faturasEnergeticosIds: faturasEnergeticosField.map(
        ({ data }) => data.id
      ),
    };
  };

  const salva = async (data, mode) => {
    startLoading();

    try {
      data = comIdsDasListasDeArquivos(data);
      if (data.estagio === "interesse" && mode === "conclude") {
        const errosAderencia = getErrorsAderencia(data);

        if (errosAderencia) {
          data.estagio = "inicioReprovado";
          data.observacoes = errosAderencia;
        } else {
          const pendenciasPreenchimento = getPendenciasPreenchimento();
          if (pendenciasPreenchimento) {
            data.observacoes = pendenciasPreenchimento;
          }

          data.estagio = "inicioAprovado";
        }
      }

      let processoData;

      if (data.id) {
        await api.http.put("/processos/" + data.id, data);
        processoData = (await api.http.get("/processos/" + data.id)).data;
        reset(dadosProcessoParaFormulario(processoData));
        selectProcesso(processoData);
        stopLoading({ severity: "success" });
      } else {
        processoData = (await api.http.post("/processos", data)).data;
        processoData = (await api.http.get("/processos/" + processoData.id)).data;
        navigate("/processo/" + processoData.id);
        stopLoading({ severity: "success" });
      }
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
      throw error;
    }
  };

  const cancela = () => {
    reset();
  };

  const [openConfirmacao, setOpenConfirmacao] = React.useState(false);

  const onSimConfirma = async (data) => {
    setOpenConfirmacao(false);
    const confirmaData = {
      ...comIdsDasListasDeArquivos(data),
      estagio: aprovando ? "inicioAprovado" : "inicioReprovado",
    };
    startLoading();
    try {
      selectProcesso(
        (await api.http.put("/processos/" + currProcesso.id, confirmaData)).data
      );
      stopLoading({ severity: "success" });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
      throw error;
    }
  };
  const onNaoConfirma = () => {
    setOpenConfirmacao(false);
  };

  const [openConfirmaDesfRecusa, setOpenConfirmaDesfRecusa] =
    React.useState(false);

  const onConfirmaDesfRecusa = async (data) => {
    setOpenConfirmaDesfRecusa(false);
    const confirmaData = {
      estagio: "interesse",
    };
    startLoading();
    try {
      selectProcesso(
        (await api.http.put("/processos/" + currProcesso.id, confirmaData)).data
      );
      stopLoading({ severity: "success" });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
      throw error;
    }
  };

  const onNaoConfirmaDesfRecusa = () => {
    setOpenConfirmaDesfRecusa(false);
  };

  const disabled = () => {
    return (
      ![
        "superAdmin",
        "gestorSENAI"
      ].includes(user.roleId) &&
      !isInterlocutorProcel(user) &&
      // quem foi escolhido como interlocutor do processo (EE, Consultor de Mercado ou Gestor)
      currProcesso?.interlocutorMercadoId !== user.id
    );
  };

  // Sentinela que nunca bate com um id real (nem com undefined) - garante que o
  // primeiro carregamento do form sempre popula, mesmo que currProcesso já venha
  // preenchido desde o mount.
  const currProcessoIdRef = React.useRef(Symbol("naoCarregadoAinda"));

  React.useEffect(() => {
    // Só reseta o form quando o processo carregado é OUTRO (ou muda de "nenhum" pra
    // "algum"/vice-versa) - uma atualização do MESMO processo em segundo plano (ex:
    // salvar o interlocutor) não deve jogar fora o que a pessoa está digitando.
    if (currProcessoIdRef.current === currProcesso?.id) return;
    currProcessoIdRef.current = currProcesso?.id;

    if (currProcesso) {
      reset(dadosProcessoParaFormulario(currProcesso));
    } else reset(defaultValues);
  }, [currProcesso]);

  const actionButtons = () => {
    if (
      isDirty ||
      !currProcesso ||
      !["inicioAprovado", "inicioReprovado"].includes(currProcesso.estagio)
    ) {
      return (
        <React.Fragment>
          <Button
            variant="outlined"
            size="large"
            sx={{ mr: 2 }}
            onClick={cancela}
            disabled={!isDirty || isSubmitting}
          >
            CANCELAR
          </Button>
          <Button
            variant="outlined"
            size="large"
            sx={{ mr: 2 }}
            onClick={() => handleSubmit(handleSalvarClick("save"))()}
          >
            SALVAR
          </Button>

          {usuarioPodeConcluirInovacao && (
            <Button
              variant="contained"
              size="large"
              color="success"
              onClick={() => handleSubmit(handleSalvarClick("conclude"))()}
              disabled={isSubmitting || currProcesso?.estagio !== "interesse"}
            >
              CONCLUIR
            </Button>
          )}
        </React.Fragment>
      );
    } else if (
      user.roleId == "superAdmin" &&
      currProcesso.estagio == "inicioReprovado"
    ) {
      return (
        <React.Fragment>
          <Button
            variant="outlined"
            size="large"
            sx={{ mr: 2 }}
            onClick={desfazerRecusa}
          >
            DESFAZER PROCESSO RECUSADO
          </Button>
        </React.Fragment>
      );
      // } else {
      //   return (
      //     <React.Fragment>
      //       <Button
      //         variant="outlined"
      //         size="large"
      //         sx={{ mr: 2 }}
      //         onClick={recusa}
      //       >
      //         RECUSAR INÍCIO
      //       </Button>
      //       <Button variant="contained" size="large" onClick={aprova}>
      //         APROVAR INÍCIO
      //       </Button>
      //     </React.Fragment>
      //   );
      // }
    }
  };

  return (
    <Paper
      variant="outlined"
      className="center-box"
      sx={{
        textAlign: "center",
        px: 4,
        pt: 2,
        pb: 3,
        maxWidth: "md",
      }}
    >
      <Dialog open={openRecusaDialog} onClose={handleCancelRecusa}>
        <DialogTitle>
          {recusaMotivos?.length > 0 ? "Confirmação de Recusa" : "Confirmação de Aprovação"}
        </DialogTitle>

        <DialogContent>
          {recusaMotivos?.length > 0 ? (
            <>
              <DialogContentText>
                Este processo será <b>recusado automaticamente</b>, pois não atende aos seguintes critérios do programa selecionado - <b>{programaSelecionado?.nome}</b>:
              </DialogContentText>
              <ul>
                {recusaMotivos?.map((motivo, idx) => (
                  <li key={idx}>
                    <DialogContentText>{motivo}</DialogContentText>
                  </li>
                ))}
              </ul>
              <DialogContentText>Deseja confirmar mesmo assim?</DialogContentText>
            </>
          ) : (
            <>
              <DialogContentText>
                Todos os critérios foram atendidos. Se prosseguir, o processo será <b>aprovado</b>.
              </DialogContentText>
              <DialogContentText>Deseja confirmar a aprovação?</DialogContentText>
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCancelRecusa}>Cancelar</Button>
          <Button
            onClick={handleConfirmRecusa}
            color={"success"}
            variant="contained"
          >
            {"Confirmar"}
          </Button>
        </DialogActions>
      </Dialog>
      <DialogoConfirmacao
        title="Atenção"
        open={openConfirmacao}
        onSim={onSimConfirma}
        onNao={onNaoConfirma}
        criteriosUrl="https://venidera.sharepoint.com/:w:/s/PotencializEE/ERQo273VKJdCnNs83V21S-4Bjc0hXA9OwW8e2BEpi25Mcw?e=SGwM8y"
      >
        {confirmacaoMsg}
      </DialogoConfirmacao>
      <DialogoConfirmacaoSimples
        title="Atenção"
        open={openConfirmaDesfRecusa}
        onSim={onConfirmaDesfRecusa}
        onNao={onNaoConfirmaDesfRecusa}
      >
        Tem certeza que deseja desfazer recusa do início?
      </DialogoConfirmacaoSimples>
      <form onSubmit={handleSubmit(aprova)}>
        <CamposProcessoInicial
          useFormRef={useFormRef}
          schema={schema}
          disabled={disabled()}
          processo={currProcesso}
          showRegiao={true}
          isProcel={isProcel}
        />
        <FormControl sx={{ my: 2 }} fullWidth>
          <Select
            field="programaId"
            useFormRef={useFormRef}
            schema={schema}
            options={programasFiltrados}
            getOptionLabel={(option) => option?.nome ?? ""}
          />
        </FormControl>

        {isProcel && currProcesso?.id && (
          <InterlocutoresSection
            processoId={currProcesso.id}
            estado={currProcesso.estado}
            interlocutorMercado={currProcesso.interlocutorMercado}
            user={user}
            onAtualizado={(processoAtualizado) => selectProcesso(processoAtualizado)}
          />
        )}

        {!isProcel && (
          <>
            <Divider>
              <h3>Demonstrativos financeiros</h3>
            </Divider>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormControl sx={{ my: 2 }} fullWidth>
                  <FileField
                    field="dreId"
                    processoId={currProcesso?.id}
                    processoAutoSave
                    disabled={disabled()}
                    fileData={currProcesso?.dre}
                    useFormRef={useFormRef}
                    schema={schema}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl sx={{ my: 2 }} fullWidth>
                  <FileField
                    processoId={currProcesso?.id}
                    processoAutoSave
                    field="balancoId"
                    disabled={disabled()}
                    fileData={currProcesso?.balanco}
                    useFormRef={useFormRef}
                    schema={schema}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </>
        )}

        <h4>Documentos técnicos</h4>
        <FileListField
          field="docsTecnicos"
          disabled={disabled()}
          useFormRef={useFormRef}
          schema={schema}
          initialFiles={currProcesso?.docsTecnicos}
        />

        <h4>Documentos financeiros</h4>
        <FileListField
          field="faturasEnergia"
          disabled={disabled()}
          useFormRef={useFormRef}
          schema={schema}
          initialFiles={currProcesso?.faturasEnergia}
        />

        <FormControl sx={{ my: 2 }} fullWidth>
          <Autocomplete
            multiple
            disableCloseOnSelect
            field="energeticos"
            disabled={disabled()}
            useFormRef={useFormRef}
            schema={schema}
            options={listaEnergeticos.filter(
              (energetico) => energetico.id != 1
            )}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <MUICheckbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {props.key}
              </li>
            )}
          />
        </FormControl>

        <FileListField
          field="faturasEnergeticos"
          disabled={disabled()}
          useFormRef={useFormRef}
          schema={schema}
          initialFiles={currProcesso?.faturasEnergeticos}
        />

        <Grid container spacing={2}>
          <Grid item xs={isProcel ? 12 : 4}>
            <FormControl sx={{ my: 2 }} fullWidth>
              <FileField
                processoId={currProcesso?.id}
                processoAutoSave
                field="cartaoCnpjId"
                disabled={disabled()}
                fileData={currProcesso?.cartaoCnpj}
                useFormRef={useFormRef}
                schema={schema}
              />
            </FormControl>
          </Grid>
          {!isProcel && (
            <>
              <Grid item xs={4}>
                <FormControl sx={{ my: 2 }} fullWidth>
                  <FileField
                    processoId={currProcesso?.id}
                    processoAutoSave
                    field="certNegInssId"
                    disabled={disabled()}
                    fileData={currProcesso?.certNegInss}
                    useFormRef={useFormRef}
                    schema={schema}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl sx={{ my: 2 }} fullWidth>
                  <FileField
                    processoId={currProcesso?.id}
                    processoAutoSave
                    field="certRegFgtsId"
                    disabled={disabled()}
                    fileData={currProcesso?.certRegFgts}
                    useFormRef={useFormRef}
                    schema={schema}
                  />
                </FormControl>
              </Grid>
            </>
          )}
        </Grid>

        <Grid container spacing={1}>
          {/* Retirado para o PROCEL (a pedido do time, pode ser pedido novamente mais a frente):
          <Grid item xs={6}>
            <FileField
              field="certNegDebtTrabId"
              label="Autodeclaração de elegibilidade assinada"
              ...
            />
          </Grid>
          */}
          {!isProcel && (
          <Grid item xs={6}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <FormControl sx={{ my: 2 }} fullWidth>
                <FileField
                  key={`certNegDebtTrabId-${declaracaoDesabilitada}`}
                  processoId={currProcesso?.id}
                  processoAutoSave
                  field="certNegDebtTrabId"
                  disabled={disabled() || declaracaoDesabilitada}
                  fileData={
                    declaracaoDesabilitada
                      ? null
                      : currProcesso?.certNegDebtTrab
                  }
                  useFormRef={useFormRef}
                  schema={schema}
                />
              </FormControl>
                <FormHelperText
                  sx={{
                    m: 0,
                    mt: 0.5,
                    cursor: declaracaoDesabilitada
                      ? 'default'
                      : 'pointer',
                    color: declaracaoDesabilitada
                      ? 'text.disabled'
                      : 'primary.main',
                    textAlign: 'center',
                    width: '100%'
                  }}
                  onClick={
                    declaracaoDesabilitada ? undefined : handleDownload2
                  }
                >
                  Baixar declaração
                </FormHelperText>
              </Box>
          </Grid>
          )}
          {!isProcel && (
            <Grid item xs={4}>
              <FormControl sx={{ my: 2 }} fullWidth>
                <FileField
                  processoId={currProcesso?.id}
                  processoAutoSave
                  field="crfId"
                  disabled={disabled()}
                  fileData={currProcesso?.crf}
                  useFormRef={useFormRef}
                  schema={schema}
                />
              </FormControl>
            </Grid>
          )}
          {/* <Grid item xs={6}>
            <FormControl sx={{ my: 2 }} fullWidth>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <FileField
                  field="termoDeImplementacaoId"
                  disabled={disabled()}
                  fileData={currProcesso?.termoDeImplementacao}
                  useFormRef={useFormRef}
                  schema={schema}
                />
            </FormControl>
          </Grid> */}
        </Grid>

        <Divider>
          <h3>Verificação de aderência</h3>
        </Divider>
        <Grid container style={{ alignItems: "center", justifyContent: "center" }}>
            {!isProcel && (
              <>
                <Button onClick={handleDownload}>
                  Clique aqui para baixar a Calculadora de Verificação de Aderência
                </Button>
                <FormControl sx={{ my: 2 }} fullWidth>
                  <FloatField
                    field="resultadoPotencialEmissoes"
                    disabled={disabled()}
                    useFormRef={useFormRef}
                    schema={schema}
                  />
                </FormControl>
              </>
            )}
            {!isProcel && (
              <>
                <FormControl sx={{ my: 2 }} fullWidth>
                  <Select
                    field="pendenciaCnd"
                    useFormRef={useFormRef}
                    schema={schema}
                    options={opcoesBooleanas2}
                    getOptionLabel={(option) => option?.label ?? ""}
                  />
                </FormControl>
                <FormControl sx={{ my: 2 }} fullWidth>
                  <Select
                    field="declaracaoAssinada"
                    useFormRef={useFormRef}
                    schema={schema}
                    disabled={disabled() || declaracaoDesabilitada}
                    options={opcoesBooleanas2}
                    getOptionLabel={(option) => option?.label ?? ""}
                  />
                </FormControl>
                <FormControl sx={{ my: 2 }} fullWidth>
                  <Select
                    field="pendenciaCadin"
                    useFormRef={useFormRef}
                    schema={schema}
                    options={opcoesBooleanas2}
                    getOptionLabel={(option) => option?.label ?? ""}
                  />
                </FormControl>
              </>
            )}
            {isProcel && (
              <FormControl sx={{ my: 2 }} fullWidth>
                <Select
                  field="sgtResponsavelVendaId"
                  useFormRef={useFormRef}
                  schema={schema}
                  disabled={disabled()}
                  options={listaResponsaveisVenda}
                  groupBy={(option) => option.vinculo}
                  getOptionLabel={(option) => (
                    <div>
                      <div>{option.representante}</div>
                      <div style={{ fontSize: '0.75rem', color: '#666' }}>{option.exemplo}</div>
                    </div>
                  )}
                />
              </FormControl>
            )}
            <FormControl sx={{ my: 2 }} fullWidth>
              <FormTextField
                field="observacoesAprovacao"
                multiline
                rows={4}
                disabled={disabled()}
                useFormRef={useFormRef}
                schema={schema}
              />
            </FormControl>

            {!isProcel && (
              <FormControl sx={{ my: 2 }} fullWidth>
                <FileField
                  processoId={currProcesso?.id}
                  processoAutoSave
                  field="potencialEmissoesId"
                  disabled={disabled()}
                  fileData={currProcesso?.potencialEmissoes}
                  useFormRef={useFormRef}
                  schema={schema}
                />
              </FormControl>
            )}
        </Grid>

        {programaSelecionado && (
          <Grid container spacing={2} justifyContent="center">
          {[
            {
              label: "Número de funcionários",
              rule: programaSelecionado?.numFuncsRule,
              value: programaSelecionado?.numFuncsValue,
              current: watchNumFuncs,
              unidade: "funcionários",
            },
            {
              label: "Gastos com energia",
              rule: programaSelecionado?.energiaRule,
              value: programaSelecionado?.energiaValue,
              current: watchValMedioFatEnergia,
              unidade: "R$/mês",
            },
            {
              label: "Potencial de emissões",
              rule: programaSelecionado?.emissoesRule,
              value: programaSelecionado?.emissoesValue,
              current: watchResultadoPotencialEmissoes,
              unidade: "tCO2e/mês",
            },
            {
              label: "Faturamento",
              rule: programaSelecionado?.faturamentoRule,
              value: programaSelecionado?.faturamentoValue,
              current: watchValorFaturamento,
              unidade: "R$",
            },
          ]
            // "Não se aplica" (regra ou valor vazios): o card inteiro some
            .filter((criterio) => criterio.rule && criterio.value != null)
            .map((criterio, idx) => (
            <Grid item xs={4} key={idx}>
              <FormControl sx={{ my: 2 }} fullWidth>
                <div className={styles.verificacaoAderenciaContainer} style={{ flexDirection: "column", alignItems: "center" }}>
                  {checkValueAgainstConstraint(
                    criterio.current,
                    (val) =>
                      criterio.rule === ">"
                        ? val >= criterio.value
                        : val <= criterio.value
                  ) ? (
                    <CheckBoxIcon fontSize="small" color="success" />
                  ) : (
                    <CancelIcon fontSize="small" color="error" />
                  )}

                  <span style={{ fontWeight: 500 }}>{criterio.label}</span>

                  <span style={{ fontSize: "12px", marginTop: "4px", color: "#555" }}>
                    {criterio.rule === ">"
                      ? "Maior que"
                      : "Menor que"}{" "}
                    {criterio.value} {criterio.unidade}
                  </span>
                </div>
              </FormControl>
            </Grid>
          ))}
        </Grid>

        )}
        <Grid container justifyContent={"center"}>
          <Grid item xs={"auto"}>
            <FormControl sx={{ my: 1 }} fullWidth>
              <Checkbox
                field="verificacaoAderencia"
                disabled={currProcesso && currProcesso.estagio !== "interesse"}
                schema={schema}
                useFormRef={useFormRef}
              />
            </FormControl>
          </Grid>
        </Grid>

        {currProcesso && currProcesso.estagio != "interesse" && (
          <React.Fragment>
            <Divider>
              <h3>
                Observações de{" "}
                {currProcesso.estagio == "inicioReprovado"
                  ? "reprovação"
                  : "aprovação"}
              </h3>
            </Divider>
            <FormControl sx={{ my: 2 }} fullWidth>
              <TextField
                value={currProcesso.observacoes}
                multiline
                rows={4}
                disabled={true}
              />
            </FormControl>
          </React.Fragment>
        )}

        <Timestamps dados={currProcesso} />

        {!disabled() && (
          <Box sx={{ mt: 2, textAlign: "center" }}>{actionButtons()}</Box>
        )}
      </form>
    </Paper>
  );
};

export default Interesse;
